import React from "react";
import CodingAssessmentDonut from "./CodingAssessmentDonut";
import DynamicLinkedGraphs from "./DynamicLinkedGraphs";
import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";

const CodingAnalysisPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div
        className="overflow-hidden inner-page-content inner-page-content--dashboard"
        // style={{ overflowY: "auto" }}
      >
        <SideBar />
        <DynamicLinkedGraphs />
      </div>
    </main>
  );
};

export default CodingAnalysisPage;
